<nz-page-header class="site-page-header" nzTitle="NDNC Report"></nz-page-header>
<div class="" nz-flex nzJustify="flex-end" style="float: right; margin-right: 20px;">
  <nz-breadcrumb [nzAutoGenerate]="true" nzSeparator=">"  >
    <nz-breadcrumb-item>
      <a [routerLink]="['']"> <span nz-icon nzType="appstore" nzTheme="outline"></span></a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>
      <a > <span nz-icon nzType="user" nzTheme="outline"></span></a>
    </nz-breadcrumb-item>
  </nz-breadcrumb>
</div>

<nz-card style="width: 100%; margin-top: 1.5rem; ">  
    <form class="my" nz-row [nzGutter]="8"  nzAlign="bottom" style="margin-bottom: 2rem; margin-top: 2rem; ">
    
        <div nz-col [nzSpan]="6" >
            
            <nz-form-control>
                <label for="MobileNumber">Mobile Number*</label>
                <input  nz-input placeholder="Mobile Number" />
                 
            </nz-form-control>
        </div>
        <div nz-col [nzSpan]="6" >
            
            <nz-form-control>
                <label for="Expiry">Date*</label>
                <nz-date-picker formControlName="Expiry" style="width: 100%;" ></nz-date-picker>
            </nz-form-control>
        </div>

        <div nz-col [nzSpan]="6"  >
        
            <button nz-button nzType="primary" class="btn-gap" (click)="onSubmit()">Submit</button>
            <button nz-button nzType="default" type="button" class="btn-gap">Back</button>
        
    </div>
    </form>
  <nz-table
  nzShowSizeChanger
  [nzTotal]="total"
  [nzPageSize]="pageSize"
  [nzPageIndex]="pageIndex"
  >
  <thead>
    <tr>
      <th nzColumnKey="summaryDate" [nzSortFn]="true">Summary Date</th>
      <th nzColumnKey="totalRequested" [nzSortFn]="true">Total Requested</th>
      <th nzColumnKey="totalRejected" [nzSortFn]="true">Total Rejected</th>
      <th nzColumnKey="totalSubmit" [nzSortFn]="true">Total Submit</th>
      <th nzColumnKey="totalRequested" [nzSortFn]="true">Total Delivered</th>
      <th nzColumnKey="totalFailed" [nzSortFn]="true">Total Failed</th>
      <th nzColumnKey="totalAwaited" [nzSortFn]="true">Total Awaited</th>
    </tr>
  </thead>
  <tbody>
    
  </tbody>
</nz-table>
  <!-- <router-outlet/> -->
</nz-card>